import React from 'react';

import router from 'next/router';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';
import AuthenticationPageContext from '@components/lpc/Authentication/AuthenticationPageContext';
import { getRoute, ROUTE } from '@services/http/Route';

import css from '../Login.module.scss';

type LostPasswordLinkProps = {
    fromFakePot?: boolean;
};
const LostPasswordLink = ({ fromFakePot }: LostPasswordLinkProps) => {
    const { t } = useTranslateLpc('lpc-authentication');
    return (
        <AuthenticationPageContext.Consumer>
            {({ setPage, pages }) => (
                <div
                    className={css['lost-password']}
                    onClick={() =>
                        fromFakePot
                            ? router.push(getRoute(ROUTE.LPC.SIGN_IN, `?page=lostPassword`))
                            : setPage(pages.lostPassword)
                    }
                >
                    <Text variant="caption_01" color="light-black-gray">
                        {t('login.lost-password')}
                    </Text>
                </div>
            )}
        </AuthenticationPageContext.Consumer>
    );
};

export default LostPasswordLink;
